<div class="twc-col">
    <span class="twc-row margin-content-left" *ngIf="layerData">
        <p class="twc-body font-bold">{{'OBJECT_BROWSER.CREATED' | translate}}:&nbsp;</p>
        <p class="twc-body twc-mr-3">{{layerData.createdAt | localizedDate}}</p>
        <p class="twc-body font-bold">{{'OBJECT_BROWSER.MODIFIED' | translate}}:&nbsp;</p>
        <p class="twc-body twc-mr-3">{{layerData.updatedAt | localizedDate}}</p>
    </span>

    <div *ngIf="isRaster">
        <span class="twc-row " *ngIf="rasterOptions.source">
            <p class="twc-body font-bold">{{'RASTER_LAYER_PROPERTIES.SOURCE' | translate}}:&nbsp;
            </p>
            <p class="twc-body twc-mr-3">{{rasterOptions.source}}</p>
        </span>
        <span class="twc-row " *ngIf="rasterOptions.sourceParams">
            <p class="twc-body font-bold">{{'RASTER_LAYER_PROPERTIES.SOURCE_PARAMS' |
                translate}}:&nbsp;</p>
            <p class="twc-body twc-mr-3">{{rasterOptions.sourceParams}}</p>
        </span>
        <span class="twc-row " *ngIf="rasterOptions.sourceType">
            <p class="twc-body font-bold">{{'RASTER_LAYER_PROPERTIES.SOURCE_TYPE' |
                translate}}:&nbsp;</p>
            <p class="twc-body twc-mr-3">{{rasterOptions.sourceType}}</p>
        </span>
    </div>

    <div *ngIf='isPointCloud'>
        <span class="twc-row" *ngIf="pointCloudOptions.points">
            <p class="twc-body font-bold">{{'LAYER_INFO.NUMBER_OF_POINTS' | translate}}:&nbsp;
            </p>
            <p class="twc-body twc-mr-3">{{pointCloudOptions.points}}</p>
        </span>

        <span class="twc-row">
            <p class="twc-body font-bold twc-mr-3">{{'LAYER_INFO.COLORS' |
                translate}}:&nbsp;
            </p>
            <p class="twc-body color-R twc-mr-3 twc-mb-3 twc-px-2">R: {{pointCloudOptions.minRed}} - {{pointCloudOptions.maxRed}}</p>
            <p class="twc-body color-G twc-mr-3 twc-mb-3 twc-px-2"> G:
                {{pointCloudOptions.minGreen}} - {{pointCloudOptions.maxGreen}}</p>
            <p class="twc-body color-B twc-mb-3 twc-px-2"> B: {{pointCloudOptions.minBlue}} - {{pointCloudOptions.maxBlue}}</p>
        </span>

        <span class="twc-row">
            <p class="twc-body font-bold twc-mr-3">{{'LAYER_INFO.INTENSITY' |
                translate}}:&nbsp;
            </p>
            <p class="twc-body twc-mr-3">{{'LAYER_INFO.MIN'
                | translate}}: {{pointCloudOptions.minIntensity}} </p>
            <p class="twc-body">{{'LAYER_INFO.MAX'
                | translate}}: {{pointCloudOptions.maxIntensity}}</p>
        </span>
    </div>

    <div *ngIf='isVectorLayer'>
        <span class="twc-row" *ngIf="layerData?.category">
            <p class="twc-body font-bold">{{'LAYER_INFO.GEOMETRY_TYPE' | translate}}:&nbsp;</p>
            <p class="twc-body twc-mr-3">{{layerData?.category}}</p>
        </span>
    </div>

    <span class="twc-row" *ngIf="layerData?.horizProjectionEPSG">
        <p class="twc-body font-bold">{{'LAYER_INFO.PROJECTION' | translate}}:&nbsp;</p>
        <p class="twc-body twc-mr-3">{{layerData?.horizProjectionEPSG}}</p>
    </span>

    <p *ngIf="layerData" class="twc-body twc-row font-bold">{{'LAYER_INFO.BOUNDING_BOX' |
        translate}}:&nbsp;</p>
    <table class="twc-table layer-table" *ngIf="layerData" attr.aria-describedby="{{'LAYER_INFO.BOUNDING_BOX_TABLE_DESC' |
            translate}}">
        <thead>
            <tr class="title-color">
                <th class="empty-col-width"></th>
                <th>X</th>
                <th>Y</th>
                <th>Z</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="title-color">{{'LAYER_INFO.MIN'| translate}}</td>
                <td class="row-background">{{layerData.minx}}</td>
                <td class="row-background">{{layerData.miny}}</td>
                <td class="row-background">{{layerData.minz}}</td>
            </tr>
            <tr>
                <td class="title-color">{{'LAYER_INFO.MAX'| translate}}</td>
                <td>{{layerData.maxx}}</td>
                <td>{{layerData.maxy}}</td>
                <td>{{layerData.maxz}}</td>
            </tr>
        </tbody>
    </table>
</div>